import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f77b6354"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_component_ion_item, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_text, { color: "primary" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.item.title), 1)
            ]),
            _: 1
          }),
          _hoisted_1,
          _createVNode(_component_ion_note, { color: "tertiary" }, {
            default: _withCtx(() => [
              _createTextVNode(" — " + _toDisplayString(_ctx.formatDateTime(_ctx.item.timestamp)) + " " + _toDisplayString(_ctx.renderTags(_ctx.item.tags)), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, [
            _createVNode(_component_ion_note, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.item.description), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}